import * as React from 'react';
import { Link } from 'react-router-dom';
import LoginLayout from './loginLayout/loginLayout';
import AgentSignup from './agentSignUp/agentSignUp';
import InvitedToSignUpNew from './invitedToSignUp/invitedToSignUpNew';
import InvitedToSignUpExisting from './invitedToSignUp/invitedToSignUpExisting';
import UserActivation from './userActivation';
import ResetPassword from './resetPassword/resetPassword';
import ForgotPassword from './forgotPassword/forgotPassword';
import AcceptInvitation from './acceptInvitation';
import RejectBrokerage from './rejectBrokerage';
import Login from './login/login';
import PartnerAuth from './partnerAuth';
import { withAppUser } from '../shared/authorization/userConsumer';
import Logo from '../assets/real-sign.svg';

const withLayout = (Component: React.Element) => function LayoutWrapper(props: any) {
  return (
    <LoginLayout>
      <Component {...props} />
    </LoginLayout>
  );
};

const authNavStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: 64,
  backgroundColor: '#0f2352',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 32px',
  zIndex: 1200,
  boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
};

const ResetPasswordWithSmartLayout = withAppUser(function ResetPasswordLayout({ user, isUserLoading, ...rest }) {
  if (isUserLoading) return null;
  if (user) {
    return (
      <div>
        <div style={authNavStyle}>
          <Link to="/agent/sessions" style={{ display: 'flex', alignItems: 'center', height: 36 }}>
            <Logo style={{ height: 32, width: 'auto' }} />
          </Link>
          <Link
            to="/agent/sessions"
            style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem', textDecoration: 'none' }}
          >
            ← Back to dashboard
          </Link>
        </div>
        <div style={{ paddingTop: 80, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f7f9fc' }}>
          <div style={{ width: '100%', maxWidth: 480, backgroundColor: '#fff', borderRadius: 16, padding: '48px 40px', boxShadow: '0 4px 24px rgba(15,98,189,0.10)' }}>
            <ResetPassword {...rest} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <LoginLayout>
      <ResetPassword {...rest} />
    </LoginLayout>
  );
});

export default {
  AgentSignup: withLayout(AgentSignup),
  InvitedToSignUpNew: withLayout(InvitedToSignUpNew),
  InvitedToSignUpExisting: withLayout(InvitedToSignUpExisting),
  UserActivation: withLayout(UserActivation),
  ResetPassword: ResetPasswordWithSmartLayout,
  ForgotPassword: withLayout(ForgotPassword),
  AcceptInvitation: withLayout(AcceptInvitation),
  RejectBrokerage: withLayout(RejectBrokerage),
  Login: withLayout(Login),
  PartnerAuth,
};

export { default as AccountSettings } from './account-settings';
export { default as Logout } from './logout';
